import restaurantsActions from '../actionTypes/restaurantsActions';

const initialState = {
  isLoading: true,
  openModal: false,
  isSubmitting: false,
  activeModalId: null,
  restaurant: null,
  cuisines: []
};

const formatted_cuisines_data = (cuisines) => {
  return cuisines.map(cuisine => ({
    cuisine_id: cuisine.id,
    cuisines_name: cuisine.name
  }))
}

export default (state = initialState, action) => {
  switch (action.type) {
    case restaurantsActions.toggleRestaurantForm:
      return {
        ...state,
        activeModalId: action.payload,
        openModal: !state.openModal,
      };
    case restaurantsActions.addNewRestaurant:
    case restaurantsActions.updateRestaurantDetails:
      return { ...state, isSubmitting: true };
    case restaurantsActions.addNewRestaurantSuccess:
    case restaurantsActions.updateRestaurantDetailsSuccess:
      return {
        ...state,
        ...action.payload,
        isSubmitting: false,
        errors: null,
        openModal: false,
      };
    case restaurantsActions.addNewRestaurantFailed:
    case restaurantsActions.updateRestaurantDetailsFailed:
      return { ...state, ...action.payload, isSubmitting: false };
    case restaurantsActions.restaurantProfileUpdate:
    case restaurantsActions.restaurantProfileUpdateFailed:
      return {
        ...state,
        ...action.payload,
        isSubmitting: false,
        isLoading: false,
      };
    case restaurantsActions.restaurantProfileUpdateSuccess:
      return {
        ...state,
        isSubmitting: false,
        errors: null,
      };
    case restaurantsActions.resetToInitialState:
      return initialState;
    case restaurantsActions.getCuisinesList:
      return {...state, ...action.payload }
    case restaurantsActions.getCuisinesListSuccess:
      return {...state, cuisines: formatted_cuisines_data(action.payload.data) }
    case restaurantsActions.getCuisinesListFailed:
      return {...state, cuisines: [] }
    case restaurantsActions.getRestaurantDetails:
      return { ...state, isLoading: true}
    case restaurantsActions.getRestaurantDetailsSuccess:
      return { ...state, restaurant: {
        ...action.payload.data.restaurant.attributes,
        restaurant_cuisines: action.payload.data.restaurant_cuisines
      }, isLoading: false}
    case restaurantsActions.getRestaurantDetailsFailed:
      return { ...state, restaurant: null,  isLoading: false}
    default:
      return state;
  }
};
